import MechanismOption from './MechanismOption'
import {
  MFA_SETTINGS_REVOKE,
  MFA_SETTINGS_SETUP,
  MFA_SETTINGS_TOTP_DESCRIPTION,
  MFA_SETTINGS_WEB_AUTHN_DESCRIPTION,
} from '../../constants/ui.labels'
import { Properties, TOTP, WEB_AUTHN } from '../../constants/mfa'
import {
  SETUP_TOTP_MECHANISM,
  SETUP_WEB_AUTHN_MECHANISM,
} from '../../constants/links'
import Button from '@talkdesk/cobalt-react-button'
import Divider from '@talkdesk/cobalt-react-divider'
import Card from '@talkdesk/cobalt-react-card'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'

const AvailableMFA = [
  {
    type: WEB_AUTHN,
    description: MFA_SETTINGS_WEB_AUTHN_DESCRIPTION,
    redirectTo: SETUP_WEB_AUTHN_MECHANISM,
    ...Properties[WEB_AUTHN],
  },
  {
    type: TOTP,
    description: MFA_SETTINGS_TOTP_DESCRIPTION,
    redirectTo: SETUP_TOTP_MECHANISM,
    ...Properties[TOTP],
  },
]

const renderDivider = (isLastElement) => (!isLastElement ? <Divider /> : null)

const renderActionButton = (isActive, onRevoke, onSetup) =>
  isActive ? (
    <Button
      htmlType='button'
      type='danger'
      variation='outline'
      size='small'
      onClick={onRevoke}
    >
      {MFA_SETTINGS_REVOKE}
    </Button>
  ) : (
    <Button
      htmlType='button'
      type='primary'
      variation='inverted'
      size='small'
      onClick={onSetup}
    >
      {MFA_SETTINGS_SETUP}
    </Button>
  )

const MechanismsList = ({ enabledMFAMechanisms, onRevoke, onSetup }) => (
  <Card>
    {AvailableMFA.map(({ redirectTo, type, color, ...settings }, index) => {
      const isActive = enabledMFAMechanisms.includes(type)
      return (
        <Box key={type}>
          <Flex gap='4' alignY='center' alignX='space-between'>
            <MechanismOption
              activeColor={color}
              {...settings}
              isActive={isActive}
            />
            <Box paddingX='5'>
              {renderActionButton(
                isActive,
                () => onRevoke(type),
                () => onSetup(redirectTo),
              )}
            </Box>
          </Flex>
          {renderDivider(index === AvailableMFA.length - 1)}
        </Box>
      )
    })}
  </Card>
)

export default MechanismsList
